mutation DocumentPoolCreate($input: DocumentPoolCreateInput!) {
  documentPoolCreate(input: $input) {
    documentPools {
      id
      extractionTypeId
      name
      description
      defaultDirectoryTypeId
      defaultDirectoryTypes {
        id
        description
      }
      defaultDocumentTypeId
      defaultDocumentTypes {
        id
        documentType
      }
      _documentFileCount {
        availableDocuments
        selectedDocuments
      }
      isShareableDefault
      isCreateCopyWithSelection
      isRetainedWithSelection
      isBusinessUnitSelector
      isDepartmentSelector
      isDocumentTypeSelector
      defaultBusinessUnitId
      defaultBusinessUnits {
        id
        name
      }
      defaultDepartmentId
      defaultDepartments {
        id
        name
        _isDeletable
      }
      userGroupId
      userGroups {
        id
        name
      }
      _isProtected
      _isModified
      _isUpdatable
      _isDeletable
      _rowTimestamp
      _isNotesExist
      notesByEntityId {
        nodes {
          id
          noteComment
          _rowTimestamp
        }
      }
    }
  }
}
